<script>
    import Picker from 'vanilla-picker'
    import { onMount } from 'svelte'

    export let color
    export let updateColor
    let parent
    let picker

    onMount(() => {
        picker = new Picker(parent)

        picker.onDone = function (color) {
            updateColor(color.hex)
        }
    })
</script>

<div
    bind:this={parent}
    class="color-picker rounded-md bg-white shadow border-gray-300 border"
    style={`background-color: ${color}`}
    id="parent" />

<style>
    .color-picker {
        width: 35px;
        height: 35px;
    }
</style>
